<template>
  <nav
    :class="[
      'fixed top-0 left-0 w-full z-50 transition-all duration-300',
      scrolled
        ? 'bg-black/90 backdrop-blur-md shadow-lg border-b border-white/5'
        : 'bg-transparent'
    ]"
  >
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex justify-between items-center">

      <!-- Logo -->
      <router-link
        :to="{ name: 'home' }"
        class="text-base font-bold tracking-tight select-none"
      >
        <span class="text-white">MT</span><span class="text-cyan-400">TECHDEV</span>
      </router-link>

      <!-- Desktop navigation -->
      <ul class="hidden md:flex items-center gap-1">
        <li v-for="link in navLinks" :key="link.name">
          <router-link
            :to="{ name: link.name }"
            class="relative px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
            :class="isActive(link.name)
              ? 'text-cyan-400'
              : 'text-gray-400 hover:text-white'"
          >
            {{ link.label }}
            <span
              v-if="isActive(link.name)"
              class="absolute bottom-0 left-3 right-3 h-px bg-cyan-400 rounded-full"
            ></span>
          </router-link>
        </li>
      </ul>

      <!-- Mobile hamburger -->
      <button
        @click="toggleMenu"
        :disabled="isButtonDisabled"
        class="md:hidden p-2 rounded-lg text-gray-400 hover:text-white hover:bg-white/10 transition-colors duration-200 cursor-pointer"
        aria-label="Toggle menu"
      >
        <svg v-if="!isMenuOpen" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
        <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Mobile menu panel -->
    <Transition name="mobile-menu">
      <div
        v-if="isMenuOpen"
        class="md:hidden border-t border-white/5 bg-black/95 backdrop-blur-md"
      >
        <ul class="max-w-6xl mx-auto px-4 py-3 flex flex-col gap-1">
          <li v-for="link in navLinks" :key="link.name">
            <router-link
              :to="{ name: link.name }"
              @click="closeMenu"
              class="block px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200"
              :class="isActive(link.name)
                ? 'text-cyan-400 bg-cyan-400/10'
                : 'text-gray-400 hover:text-white hover:bg-white/5'"
            >
              {{ link.label }}
            </router-link>
          </li>
        </ul>
      </div>
    </Transition>
  </nav>

  <!-- Mobile overlay -->
  <Transition name="overlay">
    <div
      v-if="isMenuOpen"
      @click="closeMenu"
      class="md:hidden fixed inset-0 bg-black/50 z-40"
    />
  </Transition>
</template>

<script>
export default {
  name: 'NavbarSide',
  data() {
    return {
      isMenuOpen: false,
      isButtonDisabled: false,
      scrolled: false,
      navLinks: [
        { name: 'home', label: 'Inicio' },
        { name: 'about', label: 'Sobre mí' },
        { name: 'projects', label: 'Proyectos' },
        { name: 'blog', label: 'Blog' },
        { name: 'contact', label: 'Contacto' }
      ]
    };
  },
  methods: {
    isActive(routeName) {
      return this.$route.name === routeName;
    },
    toggleMenu() {
      this.isButtonDisabled = true;
      this.isMenuOpen = !this.isMenuOpen;
      setTimeout(() => { this.isButtonDisabled = false; }, 300);
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 20;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.mobile-menu-enter-active,
.mobile-menu-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.mobile-menu-enter-from,
.mobile-menu-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.overlay-enter-active,
.overlay-leave-active {
  transition: opacity 0.2s ease;
}
.overlay-enter-from,
.overlay-leave-to {
  opacity: 0;
}
</style>
